export default __webpack_public_path__ + "static/logo_peachseoga_WH-ac5f8b8898e1903758ac097481eb3a82.png";